import React from "react";
import { Modal, Button } from "react-bootstrap";
import { EditOutlined } from "../../../../helpers/icons/antDesignIcons";

const SettingsCompanyMoreInfoModal = ({
  show,
  onClose,
  companyInfo,
  onEditCompany,
  t,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      className="csl-modal"
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>{companyInfo?.companyname || t("noData")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {t("company_id")}: {companyInfo?.companyid || t("noData")}
        </p>
        <p>
          {t("companyName")}: {companyInfo?.companyname || t("noData")}
        </p>
        <p>
          {t("zip")}: {companyInfo?.zip || t("noData")}
        </p>
        <p>
          {t("company_street")}: {companyInfo?.street || t("noData")}
        </p>
        <p>
          {t("company_house_number")}: {companyInfo?.housenr || t("noData")}
        </p>
        <p>
          {t("email")}: {companyInfo?.companyemail || t("noData")}
        </p>
        <p>
          {t("company_phone_number")}: {companyInfo?.phonenumber || t("noData")}
        </p>
        <p>
          {t("company_tax_number")}: {companyInfo?.taxnumber || t("noData")}
        </p>
        <p>
          {t("status")}:{" "}
          {companyInfo?.status === true ? t("active") : t("inactive")}
        </p>
        <p>
          {t("licenses")}: {companyInfo?.licenses || t("noData")}
        </p>
        <p>
          {t("website")}: {companyInfo?.website || t("noData")}
        </p>
        <p>
          {t("shrinkage_control") || "Shrinkage Control"}:
          {companyInfo?.shrinkage_control ? t("active") : t("inactive")}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => onEditCompany(companyInfo)}>
          <EditOutlined /> {t("edit")}
        </Button>
        <Button variant="secondary" onClick={onClose}>
          {t("cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SettingsCompanyMoreInfoModal;
